(function () {
	'use strict';

	var cartAreaSelector = '#Cart, #cart-form, .thb-cart-form, #CartDrawer, #cart-drawer, .cart-drawer, .drawer, .side-panel, .side-panel-content, .side-panel-footer';
	var dynamicCheckoutSelector = '.shopify-cleanslate, .additional-checkout-buttons, .dynamic-checkout-buttons, .cart__dynamic-checkout-buttons, [data-shopify="payment-button"]';
	var checkoutCandidateSelector = 'button, input[type="submit"], a[href], .button, .checkout-button, .cart__checkout-button, .cart-drawer__checkout-button';
	var productCandidateSelector = 'body.template-product form[action*="/cart/add"] button, body.template-product form[action*="/cart/add"] input[type="submit"], body.template-product product-form button, body.template-product .product-form button, body.template-product .product-form__submit, body.template-product .single-add-to-cart-button, body.template-product .add-to-cart, body.template-product .add_to_cart, body.template-product [data-add-to-cart]';
	var watchedNodeSelector = cartAreaSelector + ', form[action*="/cart/add"], product-form, .product-form, .product-form__submit, .single-add-to-cart-button, .add-to-cart, .add_to_cart, [data-add-to-cart], button[name="checkout"], a[href*="/checkout"]';
	var scheduled = false;

	function isElement(node) {
		return !!node && node.nodeType === 1;
	}

	function insideDynamicCheckout(el) {
		return !!(el && el.closest && el.closest(dynamicCheckoutSelector));
	}

	function textOf(el) {
		return ((el.textContent || '') + ' ' + (el.value || '') + ' ' + (el.getAttribute('aria-label') || '')).toLowerCase();
	}

	function looksLikeCheckoutButton(el) {
		var href = (el.getAttribute('href') || '').toLowerCase();
		var name = (el.getAttribute('name') || '').toLowerCase();
		return name === 'checkout' || href.indexOf('/checkout') !== -1 || textOf(el).indexOf('checkout') !== -1;
	}

	function looksLikeProductAddToCartButton(el) {
		if (!document.body || !document.body.classList.contains('template-product') || insideDynamicCheckout(el)) return false;

		var name = (el.getAttribute('name') || '').toLowerCase();
		var type = (el.getAttribute('type') || '').toLowerCase();
		var productForm = el.closest('form[action*="/cart/add"], product-form, .product-form, .product-form__buttons, .product-add-to-cart, .product-single__form');

		if (name === 'add' || el.hasAttribute('data-add-to-cart')) return true;
		if (el.classList.contains('product-form__submit') || el.classList.contains('single-add-to-cart-button')) return true;
		if (el.classList.contains('add-to-cart') || el.classList.contains('add_to_cart')) return true;

		return !!productForm &&
			(type === 'submit' || el.tagName.toLowerCase() === 'button') &&
			/add to cart|add to bag|in den warenkorb|warenkorb/.test(textOf(el));
	}

	function tagCheckoutButtons(root) {
		(root || document).querySelectorAll(checkoutCandidateSelector).forEach(function (el) {
			if (insideDynamicCheckout(el) || !looksLikeCheckoutButton(el) || !el.closest(cartAreaSelector)) return;
			el.classList.add('ai-cart-checkout-button-fix');
		});
	}

	function tagProductButtons(root) {
		if (!document.body || !document.body.classList.contains('template-product')) return;

		(root || document).querySelectorAll(productCandidateSelector).forEach(function (el) {
			if (looksLikeProductAddToCartButton(el)) {
				el.classList.add('ai-product-add-to-cart-button-fix');
			}
		});
	}

	var shippingPhrases = [
		/Free shipping included\.?/gi,
		/Shipping calculated at checkout\.?/gi,
		/Shipping and taxes calculated at checkout\.?/gi,
		/Taxes and shipping calculated at checkout\.?/gi,
		/Shipping calculated at the checkout\.?/gi,
		/Kostenloser Versand inklusive\.?/gi,
		/Gratis Versand inklusive\.?/gi,
		/Versand inklusive\.?/gi,
		/Versand wird beim Checkout berechnet\.?/gi,
		/Versandkosten werden beim Checkout berechnet\.?/gi
	];

	function cleanPolicyText(value) {
		var cleaned = value || '';
		shippingPhrases.forEach(function (pattern) {
			cleaned = cleaned.replace(pattern, '');
		});
		cleaned = cleaned.replace(/\s+\./g, '.').replace(/\.\s*\./g, '.').replace(/\s{2,}/g, ' ').trim();
		return /^tax(?:es)? included\.?$/i.test(cleaned) ? 'Tax included.' : cleaned;
	}

	function hasTaxAndShipping(text) {
		return /tax included|taxes included|steuer|mwst/i.test(text) &&
			/shipping calculated at checkout|free shipping included|shipping and taxes calculated|taxes and shipping calculated|versand/i.test(text);
	}

	function cleanCartPolicyText(root) {
		(root || document).querySelectorAll(cartAreaSelector).forEach(function (area) {
			if (!area.textContent || !hasTaxAndShipping(area.textContent)) return;

			var walker = document.createTreeWalker(area, NodeFilter.SHOW_TEXT, {
				acceptNode: function (node) {
					return hasTaxAndShipping(node.nodeValue || '') ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT;
				}
			});
			var textNodes = [];
			while (walker.nextNode()) textNodes.push(walker.currentNode);
			textNodes.forEach(function (node) {
				node.nodeValue = cleanPolicyText(node.nodeValue || '');
			});

			area.querySelectorAll('.cart-policy-text, .cart-drawer__policy, .cart__tax, .cart__shipping, .tax-note, .cart__note, p, small').forEach(function (el) {
				var text = (el.textContent || '').replace(/\s+/g, ' ').trim();
				if (text && hasTaxAndShipping(text)) el.textContent = 'Tax included.';
			});
		});
	}

	function applyCommerceFixes(root) {
		root = isElement(root) ? root : document;
		tagCheckoutButtons(root);
		tagProductButtons(root);
		cleanCartPolicyText(root);
	}

	function scheduleCommerceFixes(root) {
		if (scheduled) return;
		scheduled = true;
		(window.requestAnimationFrame || window.setTimeout)(function () {
			scheduled = false;
			applyCommerceFixes(root || document);
		});
	}

	function nodeCouldNeedFix(node) {
		return isElement(node) && (
			node.matches(watchedNodeSelector) ||
			node.querySelector(watchedNodeSelector)
		);
	}

	function startObserver() {
		if (!window.MutationObserver || !document.body) return;

		new MutationObserver(function (mutations) {
			for (var i = 0; i < mutations.length; i += 1) {
				for (var j = 0; j < mutations[i].addedNodes.length; j += 1) {
					if (nodeCouldNeedFix(mutations[i].addedNodes[j])) {
						scheduleCommerceFixes(document);
						return;
					}
				}
			}
		}).observe(document.body, { childList: true, subtree: true });
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', function () {
			applyCommerceFixes(document);
			startObserver();
		}, { once: true });
	} else {
		applyCommerceFixes(document);
		startObserver();
	}

	['cart:refresh', 'cart:updated', 'cart-drawer:open', 'cart:drawer:open', 'drawer:open', 'variant:change', 'product:variant-change'].forEach(function (eventName) {
		document.addEventListener(eventName, function () {
			scheduleCommerceFixes(document);
			window.setTimeout(function () { cleanCartPolicyText(document); }, 150);
		});
	});
})();
